import {
  ControlPosition,
  MapControl,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import React, { useEffect, useState } from "react";
import { Form, FormCheck, FormControl } from "react-bootstrap";

const CommonMapTrafficLayer = ({ children }) => {
  const map = useMap();
  const lib = useMapsLibrary("maps");
  const [showTraffic, setShowTraffic] = useState(false);

  useEffect(() => {
    if (!map) return;
  }, [map]);

  useEffect(() => {
    if (showTraffic) {
      var trafficLayer = new lib.TrafficLayer();

      trafficLayer.setMap(map);
    }

    return () => {
      if (trafficLayer) {
        trafficLayer.setMap(null);
        trafficLayer = null;
      }
    };
  }, [showTraffic]);

  return (
    <React.Fragment>
      <MapControl position={ControlPosition.BOTTOM_CENTER}>
        <div
          className="d-flex align-items-center px-3"
          style={{
            background: "#ffffffff",
            width: "auto",
            margin: "10px",
            height: "40px",
            borderRadius: "2px",
            order: 1,
          }}
        >
          <Form.Switch
            style={{ paddingTop: "2px", color: "black" }}
            label={
              <div
                className="fw-bold ps-1"
                style={{ paddingTop: "2px", color: "black" }}
              >
                Show Traffic
              </div>
            }
            checked={showTraffic}
            onChange={(e) => {
              setShowTraffic(e.target.checked);
            }}
            color="#000"
          />
        </div>
      </MapControl>
    </React.Fragment>
  );
};

export default CommonMapTrafficLayer;
